import axios from 'axios'
import { nextTick } from 'vue'
import $ from 'jquery'
import _findIndex from 'lodash/findIndex'
import get from 'lodash/get'

import {
  convert_markdown,
  is_small_screen,
  load_script,
  main_url,
  rain_emoji,
  set_css_video_color
} from '@/utils'
import PaymentsCtaMixin from '@/mixins/payments-cta-mixin'
import VideoTrackMixin from '@/mixins/video-track-mixin'
import VideoPlayerMixin from '@/mixins/video-player-mixin'
import GateFormCtaMixin from '@/mixins/gate-form-cta-mixin'

export default {
  mixins: [PaymentsCtaMixin, VideoTrackMixin, VideoPlayerMixin, GateFormCtaMixin],
  props: {
    shouldShowFooterPromo: {
      default: false
    },
    shouldShowExitIntentPromo: {
      default: false
    },
    shouldShowRegisterIntentModal: {
      default: true
    },
    affiliateUrl: {
      default: ''
    },
    isBioLinkPage: {
      default: false
    },
    playerLogo: {
      default: null
    },
    customSkin: {
      default: false
    },
    videoMessage: {
      default: ''
    }
  },
  data () {
    return {
      loaded: false,
      video: null,
      profile: null,
      playlist: [],
      player: null,
      emojis: ['😀', '💡', '👏', '🙌', '👍', '👎'],
      videoReady: false,
      currentVideo: null,
      ctaClicked: false,
      editingTitle: false,
      titleForm: new SparkForm({
        title: ''
      })
    }
  },
  computed: {
    isSelf () {
      return Spark.state.user && Spark.state.user.id === this.video.user_id
    },
    htmlDescription () {
      return convert_markdown(this.video.description || '')
    },
    autoplay () {
      if (this.shouldShowGateForm) {
        return false
      }

      return this.currentVideo.switches.video_auto ? 'any' : false
    },
    autoplayPlaylist () {
      if (this.shouldShowGateForm) {
        return false
      }

      return get(this.video, 'switches.autoplay_playlist', false)
    },
    shouldShowExitIntent () {
      return this.shouldShowExitIntentPromo || (this.video.switches.exit_intent && !this.ctaClicked)
    },
    showPlaylist () {
      return this.playlist.length > 0 && !this.video.switches.hide_playlist
    },
    showQuickConversation () {
      // because it should be used at the top of the video-show
      return this.video?.user && this.salesAssistant !== null
    },
    salesAssistant () {
      return this.video?.sales_assistant
    },
    quickResponses () {
      if (!this.salesAssistant) {
        return ['Thanks', 'I\'m interested', '👍']
      }

      return this.salesAssistant.faqs.filter(faq => faq.default).map(faq => faq.question)
    },
    hasReplyWithVideoCta () {
      return this.video.call_to_actions.filter(cta => {
        return cta.type === this.constants.App_Models_CallToAction.TYPE_VIDEO_REPLY
      }).length > 0
    },
    resolutionRatio () {
      if (this.currentVideo.video_resolution) {
        const { height, width } = this.currentVideo.video_resolution
        const isSmallScreen = is_small_screen()
        const isRatioGreaterThanOne = width / height >= 1

        if (
          isSmallScreen ||
          (!isSmallScreen && isRatioGreaterThanOne)
        ) {
          return `${height / width * 100}%`
        }
      }

      return '56.25%'
    }
  },
  methods: {
    main_url,
    onVideoLoaded () {
      this.initTrackData(this.video.canonical)
      this.initTrack()
      this.initCallToActions()
      this.onKeyDown()
      this.initGateFormCTA(
        this.video.canonical,
        this.video.call_to_actions
      )

      if (this.customSkin) {
        set_css_video_color(this.currentVideo)
      }

      this.loaded = true

      if (this.currentVideo.transcoding) {
        this.checkTranscoding()
      }
    },
    ctaFormSubmitted (submission) {
      this.trackFormSubmission(submission)

      if (this.shouldShowGateForm) {
        this.submittedGateForm()

        $([document.documentElement, document.body]).animate({
          scrollTop: 0
        }, 500)

        this.playVideo()
      }
    },
    onKeyDown () {
      $(document).keydown((e) => {
        const tagName = e.target.tagName.toLowerCase()

        if (tagName === 'textarea' || tagName === 'input') {
          return
        }

        if (e.keyCode === 32 && this.player !== null) {
          e.preventDefault()

          this.player.paused() ? this.player.play() : this.player.pause()
        }
      })
    },
    onPlayReady (player) {
      if ('playerRef' in this) {
        this.playerRef = player
      }

      this.player = player
      this.player.on('ended', () => {
        this.trackWatch()
        this.checkPlaylist()
      })
      this.player.on('loadedmetadata', (e) => {
        this.videoReady = true
        $('#video').find('.video-js').removeClass('vjs-seeking')
        if (!this.currentVideo.video_resolution) {
          const width = this.player.videoWidth()
          const height = this.player.videoHeight()
          axios.put(this.router('api.video.resolution.update', { video: this.currentVideo.id }), { width, height })
        }
      })
      this.player.on('loadeddata', () => {
        this.player.width($('#video').width())
      })
      this.player.on('play', () => {
        if (!this.videoReady) {
          $('#video').find('.video-js').addClass('vjs-seeking')
        }
        $('.dubb-video .message').remove()
        this.cancelPausedVideoWatch()
      })
      this.player.on('pause', () => {
        this.trackPausedVideoWatch(this.player, () => {
          this.trackWatch()
        })

        this.$refs.registerIntentModalRef?.show()
      })
      this.player.on('error', () => {
        this.player.addClass('vjs-waiting')
        this.player.removeClass('vjs-paused')
      })
    },
    checkPlaylist () {
      if (this.playlist.length === 0 || this.video.switches.autoplay_playlist === false) {
        return
      }
      const currentIndex = _findIndex(this.playlist, { id: this.currentVideo.id })
      if (currentIndex >= 0 && currentIndex + 1 <= this.playlist.length - 1) {
        this.goPlaylist(this.playlist[currentIndex + 1])
      }
    },
    goPlaylist (item) {
      if (this.currentVideo && this.currentVideo.id === item.id) {
        return
      }

      this.currentVideo = item
      nextTick(() => {
        this.player.autoplay(this.autoplayPlaylist)
        this.$refs.player.reload()

        if (!this.video.switches.hide_playlist) {
          this.$refs.playlist.moveCurrentToCenter()
        }
      })
    },
    clickCallToAction (action) {
      this.ctaClicked = true
      switch (action.type) {
        case this.constants.App_Models_CallToAction.TYPE_VIDEO_REPLY:
          this.trackCallToAction(action)
          this.$refs.replyWithVideo.open()
          return
        case this.constants.App_Models_CallToAction.TYPE_FORM:
          if (action.data.form_as_modal) {
            this.$refs.formCta.open()
          }
          return
        case this.constants.App_Models_CallToAction.TYPE_MESSAGE:
          this.trackCallToAction(action)
          window.Swal.fire({
            showConfirmButton: true,
            text: action.data.message
          })
          return
      }

      this.trackCallToAction(action)
    },
    sendEmoji (emoji) {
      rain_emoji(emoji, 50)
      this.trackEmoji(emoji)
    },
    checkTranscoding () {
      setTimeout(() => {
        axios.get(this.router('api.video.show', { video: this.currentVideo.id }))
          .then(resp => {
            if (!resp.data.video.transcoding) {
              location.reload()
            } else {
              this.checkTranscoding()
            }
          })
      }, 1000)
    },
    playVideo () {
      if (this.player !== null) {
        this.player.play()
      }
    },
    editTitle () {
      this.editingTitle = true
      this.titleForm.title = this.currentVideo.title
    },
    submitTitleForm () {
      Spark.patch(this.router('api.video.patch', { video: this.currentVideo.id }), this.titleForm)
        .then(resp => {
          this.currentVideo.title = resp.title
          this.editingTitle = false
        })
    },
    initCallToActions () {
      this.video.call_to_actions.forEach(cta => {
        if (!cta.script) {
          return
        }

        let cb = null

        if (cta.type === this.constants.App_Models_CallToAction.TYPE_PAYMENTS && cta.sub_type === this.constants.App_Models_CallToAction.SUB_TYPE_PAYPAL) {
          cb = () => {
            this.initPaypalContainer(cta, '#paypal-button-container')
          }
        }

        load_script(cta.script, cb)
      })
    }
  }
}
